import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useMemo } from 'react';
import { SmartLinkStatus } from '../../constants';
import Container from './components/container';
import { FlexibleUiAnalyticsContext, FlexibleUiContext, FlexibleUiOptionContext } from '../../state/flexible-ui-context';
import { getContextByStatus, getRetryOptions } from './utils';
import { useAISummaryConfig } from '../../state/hooks/use-ai-summary-config';

/**
 * This represents a Flexible Card: a link represented by a card with metadata.
 * This is the container in which all Flexible UI Blocks and Elements exist.
 * Note: TitleBlock is mandatory for a Flexible Card to render.
 * @see Container
 */
var FlexibleCard = function FlexibleCard(_ref) {
  var _details$meta2;
  var analytics = _ref.analytics,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'flexible' : _ref$appearance,
    cardState = _ref.cardState,
    children = _ref.children,
    id = _ref.id,
    onAuthorize = _ref.onAuthorize,
    onClick = _ref.onClick,
    onError = _ref.onError,
    onResolve = _ref.onResolve,
    renderers = _ref.renderers,
    showAuthTooltip = _ref.showAuthTooltip,
    showHoverPreview = _ref.showHoverPreview,
    hoverPreviewOptions = _ref.hoverPreviewOptions,
    actionOptions = _ref.actionOptions,
    testId = _ref.testId,
    ui = _ref.ui,
    url = _ref.url;
  var aiSummaryConfig = useAISummaryConfig();
  var cardType = cardState.status,
    details = cardState.details;
  var status = cardType;
  var context = useMemo(function () {
    return getContextByStatus({
      aiSummaryConfig: aiSummaryConfig,
      response: details,
      id: id,
      renderers: renderers,
      actionOptions: actionOptions,
      status: status,
      url: url
    });
  }, [aiSummaryConfig, details, id, renderers, actionOptions, status, url]);
  var retry = getRetryOptions(url, status, details, onAuthorize);
  var _ref2 = context || {},
    title = _ref2.title;
  var analyticsContext = useMemo(function () {
    var _details$meta;
    return analytics ? _objectSpread(_objectSpread({}, analytics), {}, {
      display: appearance,
      extensionKey: details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 ? void 0 : _details$meta.key
    }) : undefined;
  }, [analytics, appearance, details === null || details === void 0 || (_details$meta2 = details.meta) === null || _details$meta2 === void 0 ? void 0 : _details$meta2.key]);
  useEffect(function () {
    switch (status) {
      case SmartLinkStatus.Resolved:
        if (onResolve) {
          onResolve({
            title: title,
            url: url
          });
        }
        break;
      case SmartLinkStatus.Errored:
      case SmartLinkStatus.Fallback:
      case SmartLinkStatus.Forbidden:
      case SmartLinkStatus.NotFound:
      case SmartLinkStatus.Unauthorized:
        if (onError) {
          onError({
            status: status,
            url: url
          });
        }
        break;
    }
  }, [onError, onResolve, status, title, url]);
  return /*#__PURE__*/React.createElement(FlexibleUiAnalyticsContext.Provider, {
    value: analyticsContext
  }, /*#__PURE__*/React.createElement(FlexibleUiOptionContext.Provider, {
    value: ui
  }, /*#__PURE__*/React.createElement(FlexibleUiContext.Provider, {
    value: context
  }, /*#__PURE__*/React.createElement(Container, _extends({
    testId: testId
  }, ui, {
    onClick: onClick,
    retry: retry,
    showHoverPreview: showHoverPreview,
    hoverPreviewOptions: hoverPreviewOptions,
    actionOptions: actionOptions,
    showAuthTooltip: showAuthTooltip,
    status: status
  }), children))));
};
export default FlexibleCard;